"use client";
import { ElProps } from "@/type";
import { cn } from "utils";
import { FC } from "react";
import Link from 'next/link'
import { BNB_SOCIAL_LINK } from "@/const";

interface ContactUsProps extends ElProps {
  svgMode: 'dark' | 'light'
}

const Item = ({itemData, svgMode}: {itemData: any, svgMode: string}) => {
  return (
    <Link className={cn("w-4 h-4 md:w-6 md:h-6")} href={itemData.href} key={itemData.icon} target="_blank">
      <img src={`${itemData.icon}-${svgMode}.svg`} alt={itemData.alt} />
    </Link>
  )
}

export const ContactUs: FC<ContactUsProps> = ({ className, svgMode }) => {
  return (
    <div className={cn('flex gap-6', className)}>
      {BNB_SOCIAL_LINK.map(i => {
        return <Item itemData={i} svgMode={svgMode} key={i.alt} />
      })}
    </div>
  )
}